import Coin from '../components/coin/Coin'

const CoinDetails = () => {
  return <Coin />
}

export default CoinDetails
